// BRSK Group Global JS

document.addEventListener('DOMContentLoaded', () => {
  console.log('BRSK Group Theme Initialized.');

  // CURSOR LOGIC
  const cursor = document.getElementById('cursor');
  const ring = document.getElementById('cursorRing');
  
  if (cursor && ring && matchMedia('(pointer:fine)').matches) {
    let mx = 0, my = 0, rx = 0, ry = 0;
    
    document.addEventListener('mousemove', (e) => {
      mx = e.clientX;
      my = e.clientY;
      cursor.style.left = mx + 'px';
      cursor.style.top = my + 'px';
    });

    function animRing() {
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      ring.style.left = rx + 'px';
      ring.style.top = ry + 'px';
      requestAnimationFrame(animRing);
    }
    animRing();

    // Dynamic hover effect on links, buttons, and form controls
    document.addEventListener('mouseover', (e) => {
      const isInteractive = e.target.closest('a, button, .product-card, .philosophy-card, input, select, textarea, .swatch, [role="button"]');
      if (isInteractive) {
        ring.classList.add('hovered');
      } else {
        ring.classList.remove('hovered');
      }
    });
  }

  
  // Sticky header logic
  const header = document.querySelector('header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 50) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    });
  }

  // Scroll Animations
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.15
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        // Optional: Stop observing once animated
        // observer.unobserve(entry.target); 
      }
    });
  }, observerOptions);

  document.querySelectorAll('.animate-on-scroll').forEach(el => {
    observer.observe(el);
  });
});

